<template>
  <v-layout>
    <v-card 
      class="mx-auto justify-center text-center"
      width="600"
      style="padding-top: 30px;"
      elevation="10"
    >
      <v-card-title primary-title class="justify-center">
        <div>
          <h3 class="headline text--accent-2">{{ title }}</h3>
        </div>
      </v-card-title>

      <v-form class="h-full overflow-y-scroll">
        <v-text-field
          v-model="name"
          label="Name"
          outlined
          type="text"
          autocomplete="off"
          class="form-field mt-1"
        />

        <v-text-field
          v-model="password"
          label="Passwort"
          outlined
          type="password"
          autocomplete="off"
          class="form-field"
        />

        <v-select
          v-model="role"
          :items="roleOptions"
          label="Rechte"
          item-text="text"
          item-value="value"
          outlined
          class="form-field"
        ></v-select>

        <v-text-field
          v-model="tour_id"
          label="Aktuelle Tour ID"
          outlined
          type="text"
          autocomplete="off"
          class="form-field"
          disabled
        />

        <v-text-field
          v-model="last_activity"
          label="Letzte Aktivität"
          outlined
          type="text"
          autocomplete="off"
          class="form-field"
          disabled
        />

        <v-row class="my-3 mx-2">
          <v-col class="text-right">
            <v-btn 
              color="red" 
              elevation="2"
              outlined 
              class="mr-4" 
              @click="btnCancel"
            >
              Abbrechen
            </v-btn>
            <v-btn
              color="green" 
              elevation="2"
              outlined 
              @click="saveData"
            >
              Speichern
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </v-layout>
</template>

<script>
import router from "@/router";

export default {
  name: 'FormDriver',

  data() {
    return {
      title: 'Fahrer',
      table: 'driver',
      mainview: 'ListDriver',
      id: '',
      name: '',
      password: '',
      role: '',
      tour_id: '',
      qty_tours: 0,
      qty_articles: 0,
      last_activity: '',
      isLoading: true,
      roleOptions: [
        { text: 'Admin', value: 'ADMIN' },
        { text: 'Lager', value: 'WAREHOUSE' },
        { text: 'Fahrer', value: 'DRIVER' },
        { text: 'Extern', value: 'EXTERNAL' }
      ],
    };
  },

  created() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.fetchDriver();
    } else {
      this.isLoading = false;
    }
  },

  methods: {
    async fetchDriver() {
      console.log('Fetching Driver...');
      this.isLoading = true;
      const param = {
        table: 'driver',
        statement: 'select',
        type: 'detail',
        where: 'true',
        selector: 'id',
        value: this.id,
        short: 'false',
        extension: ''
      };

      try {
        const result = await this.$func.queryAPI(param, {});
        if (result.length > 0) {
          const driver = result[0];
          this.name = driver.name;
          this.password = driver.password;
          this.role = driver.role ;
          this.tour_id = driver.tour_id;
          this.qty_tours = driver.qty_tours;
          this.qty_articles = driver.qty_articles;
          this.last_activity = driver.last_activity;
          console.log('Driver details loaded:', driver);
        }
      } catch (error) {
        console.error('Error fetching driver:', error);
      } finally {
        this.isLoading = false;
      }
    },

    async saveData() {
      try {
        const param = {
          table: this.table,
          statement: this.id ? 'update' : 'insert',
          type: '',
          where: 'true',
          selector: 'id',
          value: this.id,
          short: 'false',
          extension: ''
        };

        const data = {
          name: this.name,
          password: this.password,
          role: this.role,
          
        };

        await this.$func.queryAPI(param, data);
        this.$router.push({ name: this.mainview });
      } catch (error) {
        console.error('Error saving driver:', error);
      }
    },

    btnCancel() {
      router.push({ name: this.mainview });
    }
  },

  watch: {
    id: {
      immediate: true,
      handler(newId) {
        if (newId) this.fetchDriver();
      }
    }
  }
};
</script>

<style scoped>
.form-field {
  display: table;
  margin: 0 auto;
  width: 350px;
}
</style>
